@if(isOpen){
<div class="tw-absolute tw-z-10 tw-py-2 tw-bg-white tw-rounded-lg tw-border tw-border-[#e2e2e2] tw-flex-col tw-gap-1 tw-inline-flex tw-text-left {{classes}}"
  [@fadeIn]="{params: { delay: 300}}">
  <button
    class="tw-flex tw-py-2 tw-px-3 disabled:tw-opacity-[0.3]  tw-whitespace-nowrap tw-justify-start tw-items-center tw-gap-2 tw-text-primary-950 tw-text-sm tw-font-medium tw-transition-all hover:tw-bg-grey-100"
    *ngFor="let option of options" (click)="onOptionClick(option)"  [disabled]="(completed && option.itemType==='Available' && campaignType!='Interactive Tour') || isExpired"

    >
    <div class="tw-flex tw-flex-col">
      <div class="tw-flex tw-flex-row tw-items-center tw-gap-2">
        <span *ngIf="option.prefixIcon">
          <i-icon [name]="option.prefixIcon" class="tw-w-[18px] tw-h-[18px] tw-text-grey-750 !tw-block"></i-icon>
        </span>
        <div class="tw-text-sm tw-leading-[18px] tw-font-medium tw-text-black">
          {{ option.text }} 
        </div>
        <span *ngIf="option.suffixIcon">
          <i-icon [name]="option.suffixIcon" class="tw-w-[18px] tw-h-[18px] tw-text-grey-750 !tw-block"></i-icon>
        </span>
      </div>
      <div *ngIf="option.subText" class="tw-text-xs tw-text-mercury-950 tw-pl-[26px]">
        {{ option.subText }}
      </div>
    </div>
  </button>
</div>
}
